<template>
  <div class="product-list">
   <!--搜索表单-->
   <div class="common-seach-wrap">
 
     <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
       <el-form-item label="用户名称"><el-input size="small" v-model="searchForm.user_search" placeholder="请输入用户ID或用户名称"></el-input></el-form-item>
    
       <el-form-item>
         <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
       
       </el-form-item>
       <div class="common-level-rail" style="margin-right:20px;">
          <el-button size="small" @click="batchExport">批量导出</el-button>
        </div>
     </el-form>
   </div>


   <!--内容-->
   <div class="product-content">
     <div class="table-wrap">
       <el-table size="small" :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange" v-loading="loading"   >
        <el-table-column type="selection" width="45"></el-table-column>
         <el-table-column prop="supply_id" label="用户信息" width="300px">
           <template slot-scope="scope">
              <div class="name" >
                <p>ID：{{scope.row.user_id}}</p>
                 <p>名称：{{scope.row.nickName}}</p>
                
               </div>
           </template>
         </el-table-column>

        <el-table-column prop="total_good_payment" label="总佣金"></el-table-column>
        <el-table-column prop="total_dsetle_num" label="待结算"></el-table-column>
          <el-table-column prop="total_ysetle_num" label="已结算"></el-table-column>
         
       </el-table>
     </div>
   </div>
   <!--分页-->
   <div class="pagination">
     <el-pagination
       @size-change="handleSizeChange"
       @current-change="handleCurrentChange"
       background
       :current-page="curPage"
       :page-sizes="[20, 100,500, 1000]"
       layout="total,sizes, prev, pager, next, jumper "
       :total="totalDataNumber"
     ></el-pagination>
     
   </div>

 </div>
</template>

<script>
 import StatisticsApi from '@/api/statistics.js';
 import qs from 'qs';
 export default{
   components:{
   },
   data(){
     return{
       /*是否正在加载*/
       activeName: 'type7',
       loading: true,
       tableData:[],
       /*一页多少条*/
       pageSize: 20,
       /*一共多少条数据*/
       totalDataNumber: 0,
       /*当前是第几页*/
       curPage: 1,
       /*搜索参数*/
       searchForm: {
         user_search: '',
         supply_search:""
       },
       /*数据对象*/
       dataModel:{},
       /*选中的*/
      multipleSelection: [],

     }
   },
   provide: function () {
     return {
       dataModel: this.dataModel
     }
   },
   created() {

     this.getData();
   },
   methods:{
     /*选择第几页*/
     handleCurrentChange(val) {
       let self = this;
       self.loading = true;
       self.curPage = val;
       self.getData();
     },

     /*每页多少条*/
     handleSizeChange(val) {
       this.pageSize = val;
       this.getData();
     },
      /*选择数据*/
    handleSelectionChange(e) {
      this.multipleSelection = e;
    },


     /*搜索查询*/
     onSubmit() {
       this.curPage = 1;
       this.getData();
     },

     /*获取数据*/
     getData() {
       let self = this;
       let Params = self.searchForm;
       Params.limit =JSON.stringify({
        "page":self.curPage,
        "list_rows": self.pageSize
       }) 
       Params.type = self.activeName;
       self.loading = true;
       StatisticsApi.getUserCommission(Params, true)
         .then(res => {
           self.tableData = res.data.list.data;
           self.totalDataNumber = res.data.list.total;
           self.loading = false;
         })
         .catch(error => {});
     },
     batchExport(){//批量导出
        // 勾选需要导出的数据
        let ids = [];
      let params = this.multipleSelection;
      console.log("params",params)
      params.forEach((param)=>{
        ids.push(param.user_id);
      })
      ids = ids.join(',');
      // 筛选条件
      // 商品状态
      var parmasa =  this.searchForm?this.searchForm:{};
      console.log("parmasa",parmasa)
      parmasa["list_rows"] = this.pageSize
      parmasa["page"] = this.curPage
      if(ids.length > 0){
        // console.log(this.searchForm)
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/product.product/exportUsercommission?' + 
        qs.stringify(parmasa)+'&ids='+ids;
        
      }else{
        this.$message({
            message: '请选择要导出的数据',
            type: 'error'
          });
      }
   

    },

   }
 }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/statistics/usercommission/index.vue